import { Component } from '@angular/core';

@Component({
  selector: 'app-header-content-area',
  templateUrl: './header-content-area.component.html',
  styleUrl: './header-content-area.component.scss',
  standalone: false,
})
export class HeaderContentAreaComponent {}
